import { Component, OnInit } from '@angular/core';
import { DadosService } from '../../db/dados.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-meus-pedidos',
  templateUrl: './meus-pedidos.component.html',
  styleUrls: ['./meus-pedidos.component.scss']
})
export class MeusPedidosComponent implements OnInit {
  pedidos=[];
  constructor(
    private dados: DadosService,
    private router: Router) { }

  ngOnInit() {
  }

  meusPedidos() {
    this.pedidos = this.dados.meusPedidos();
    return this.pedidos;
  }

  limpar(){
     this.dados.meusPedidosLimpar();
  }

  repetir(pedido) {
    this.dados.regAnalytics(pedido.items[0].fornecedor,'acessos','repetirPedido',1);
    pedido.items.forEach(item => {
      let preco = this.dados.getPrecoVenda(item.fornecedor, item.produto);
      if (preco > 0) {
        this.dados.addItem(item.fornecedor, item.produto, item.qtde, preco);
      }
    });
    this.router.navigate(['/main']);
  }

}
